var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindowFrameOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 464H480V320H432V464H80V320H32V464H24C10.745 464 0 474.745 0 488V488C0 501.255 10.745 512 24 512H488C501.255 512 512 501.255 512 488V488C512 474.745 501.255 464 488 464ZM480 32C480 14.375 465.625 0 448 0H64C46.375 0 32 14.375 32 32V272H480V32ZM232 224H80V48H232V224ZM432 224H280V48H432V224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowFrameOpen);
export default __webpack_public_path__ + "static/media/window-frame-open.ca1ab88f30c8a0aa7824a0372642770b.svg";
export { ForwardRef as ReactComponent };